<template>
  <div>
    <a-row>
      <a-col
        :sm="{ span: 24 }"
        :md="{ span: 24 }"
        :xl="{ span: 20, offset: 2 }"
        style="margin-top: 10px"
      >
        <div class="card-container">
          <a-tabs type="card" defaultActiveKey="1" @change="callback">
            <a-tab-pane key="1" tab="Primer finder">
              <a-row>
                <a-col :span="24" style="margin-top: 10px">
                  <span style="font-size: 20px">
                    <a-icon type="search" style="margin: 0px 10px"></a-icon
                    >Searching by gene :</span
                  >
                  <a-input
                    style="width: 60%; margin-left: 10px"
                    @pressEnter="changeGene"
                    v-model="value"
                    defaultValue="SIRT7"
                  ></a-input>
                </a-col>
                <a-col :span="24" style="margin-top: 20px">
                  <primer v-bind:gene="this.gene"
                /></a-col>
              </a-row>
            </a-tab-pane>
          </a-tabs>
        </div>
      </a-col>
    </a-row>
  </div>
</template>
<script>
// import XEUtils from "xe-utils";
// import axios from "axios";
import primer from "./primerPage.vue";

export default {
  components: { primer },
  data() {
    return {
      value: "SIRT7",
      gene: "SIRT7",
    };
  },
  methods: {
    changeGene() {
      // 切换查找的基因
      this.gene = this.value;
    },
  },
};
</script>
<style scpoed>
.h1 {
  font-size: 40px;
  font-weight: bolder;
}
.keyword-lighten {
  color: #000;
  background-color: #ffff00;
}
.card-container {
  background: #f5f5f5;
  overflow: hidden;
  padding: 4px;
}
</style>
